import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { EpisodesHeaderSection } from './sections/EpisodesHeaderSection';
import { EpisodesCatalogSection } from './sections/EpisodesCatalogSection';
import { getPublishedEpisodes } from 'shared/utils/getEpisode';
import { useScrollReveal } from 'shared/hooks/useScrollReveal';

export default function Episodes() {
  const { t } = useTranslation('episodes');
  const allFilter = t('filter.all');
  const [activeFilter, setActiveFilter] = useState(allFilter);
  const headingReveal = useScrollReveal({ animation: 'float-up', delay: 360 });
  const subtitleReveal = useScrollReveal({ animation: 'float-up', delay: 480 });

  const publishedEpisodes = getPublishedEpisodes()

  const filters = useMemo(() => {
    const categories = publishedEpisodes.flatMap((episode) => episode.category);
    return [allFilter, ...categories];
  }, [publishedEpisodes, allFilter]);

  const filteredEpisodes =
    activeFilter === allFilter
      ? publishedEpisodes
      : publishedEpisodes.filter((episode) => episode.category === activeFilter);

  return (
    <div className="pt-8 pb-20 md:pb-40 px-6 lg:px-12 max-w-7xl mx-auto">
      <EpisodesHeaderSection />
      {publishedEpisodes.length > 0 ? (
        <EpisodesCatalogSection
          activeFilter={activeFilter}
          onFilterChange={setActiveFilter}
          filteredEpisodes={filteredEpisodes}
          filters={filters}
        />
      ) : (
        <div className="text-center py-24 md:py-40">
          <p ref={headingReveal.ref} style={headingReveal.style} className="font-serif text-4xl md:text-5xl text-on-surface mb-4">{t('empty.heading')}</p>
          <p ref={subtitleReveal.ref} style={subtitleReveal.style} className="text-on-surface-variant text-lg font-light">{t('empty.subtitle')}</p>
        </div>
      )}
    </div>
  );
}
